var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02693 16.9479C9.45625 20.3811 13.6223 23.0304 17.0288 23.0304C18.5593 23.0304 19.8999 22.4959 20.9822 21.3079C21.6089 20.6069 22 19.7873 22 18.9794C22 18.3853 21.776 17.815 21.2177 17.4113L17.5757 14.8213C17.0175 14.4412 16.5541 14.2511 16.125 14.2511C15.5933 14.2511 15.1072 14.5601 14.5603 15.0946L13.7173 15.9264C13.5881 16.0568 13.421 16.1165 13.2653 16.1165C13.0868 16.1165 12.9121 16.045 12.7906 15.9857C12.0576 15.5934 10.7968 14.5126 9.62334 13.3482C8.46124 12.1842 7.37889 10.9247 6.99912 10.1884C6.94215 10.0576 6.87001 9.89108 6.87001 9.71317C6.87001 9.55883 6.91557 9.4041 7.04849 9.27371L7.89161 8.4062C8.4119 7.85992 8.73469 7.38472 8.73469 6.83806C8.73469 6.41039 8.52959 5.94735 8.13843 5.38891L5.58639 1.78922C5.17244 1.21899 4.59142 0.969604 3.94961 0.969604C3.16728 0.969604 2.35836 1.32582 1.65959 2.00287C0.508889 3.10798 0 4.47388 0 5.98271C0 9.39232 2.59762 13.5265 6.02693 16.9479Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.7cb67c721223833cd1658504df0d5970.svg";
export { ForwardRef as ReactComponent };